import { Modal, ModalOverlay, ModalContent, Flex, ModalBody, Text, useDisclosure } from '@chakra-ui/react'
import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Column } from '@ubirider/pick-component-library'
import { getVivaWalletPaymentInfo } from '../../api/payment'
import { RedirectModal } from '../RedirectModal'
import { useUser } from '../../context/DataProvider'

export function NoCardsModal({ isOpen, onOpen, onClose }) {
  const { t } = useTranslation()

  const initialRef = useRef(null)
  const finalRef = useRef(null)

  const { user } = useUser()

  const { isOpen: isOpenRedirect, onOpen: onOpenRedirect, onClose: onCloseRedirect } = useDisclosure()

  const [orderCode, setOrderCode] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleAddPayment = async () => {
    try {
      setLoading(true)
      const res = await getVivaWalletPaymentInfo(user, true)
      setOrderCode(res.data.orderCode)
      onOpenRedirect()
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      initialFocusRef={initialRef}
      finalFocusRef={finalRef}
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      size={{ sm: 'xs', md: 'md', lg: 'xl', xl: 'xl' }}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <Flex
            direction='column'
            align='center'
            justifyContent='center'
            p={{ sm: '24px 0px', md: '24px 0px', lg: '32px 56px', xl: '32px 56px' }}
            gap='32px'
          >
            <Column css={{ gap: 8 }}>
              <Text fontWeight='700' fontSize='24px' color='neutral.800' align='center'>
                Sem métodos de pagamento disponíveis
              </Text>
              <Text fontWeight='600' fontSize='16px' color='neutral.600' align='center'>
                Para liquidar o valor pendente por favor adicione um método de pagamento
              </Text>
            </Column>

            <Flex gap='16px' display={{ sm: 'none', md: 'flex', lg: 'flex', xl: 'flex' }}>
              <Button
                onClick={onClose}
                style='outline'
                type='neutralLight'
                label={t('acqua_vias.common_ok')}
                css={{ width: '152px' }}
              />
              <Button
                onClick={handleAddPayment}
                loading={loading}
                style='solid'
                type='neutralDark'
                label={t('acqua_vias.payment_methods_add_button')}
              />
            </Flex>
            <Flex
              gap='16px'
              alignSelf='stretch'
              direction='column'
              display={{ sm: 'flex', md: 'none', lg: 'none', xl: 'none' }}
            >
              <Button
                onClick={handleAddPayment}
                loading={loading}
                style='solid'
                type='neutralDark'
                label={t('acqua_vias.payment_methods_add_button')}
                css={{ width: '100%' }}
              />
              <Button
                onClick={onClose}
                style='outline'
                type='neutralLight'
                label={t('common.ok')}
                css={{ width: '100%' }}
              />
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>

      <RedirectModal isOpen={isOpenRedirect} onClose={onCloseRedirect} orderCode={orderCode} />
    </Modal>
  )
}
